import type { Locale } from '~/lib/i18n/shared'

interface PageMeta {
  title: string
  description: string
  keywords?: string
}

type PageMetaMap = Record<Locale, PageMeta>

export const PAGE_META: Record<string, PageMetaMap> = {
  '/': {
    'zh-CN': {
      title: '食べ旅/美食之旅 — 日本百名店餐厅发现与 AI 预订',
      description: '探索日本顶级 100 餐厅，支持多语言地图发现与 AI 智能预订助手。',
      keywords: '日本美食,百名店,餐厅预订,AI点餐助手,东京美食,大阪美食,食べ旅,TabeTabi',
    },
    'zh-TW': {
      title: '食べ旅/美食之旅 — 日本百名店餐廳發現與 AI 預訂',
      description: '探索日本頂級 100 餐廳，支持多語言地圖發現與 AI 智能預訂助手。',
      keywords: '日本美食,百名店,餐廳預訂,AI點餐助手,東京美食,大阪美食,食べ旅,TabeTabi',
    },
    'en': {
      title: 'TabeTabi — Japan Top 100 Restaurants & AI Booking',
      description: 'Discover curated Japan Hyakumeiten restaurants with interactive maps and AI assistance.',
      keywords: 'Japan Food,Hyakumeiten,Restaurant Booking,AI Ordering,Tokyo Dining,TabeTabi',
    },
    'ja': {
      title: '食べ旅 — 日本百名店レストラン発見とAI予約',
      description: '日本のトップ100レストランを探索。多言語マップとAIアシスタントで最高の食体験を。',
      keywords: '日本食,百名店,レストラン予約,AIアシスタント,東京グルメ,食べ旅,TabeTabi',
    },
    'ko': {
      title: 'TabeTabi — 일본 백명점 레스토랑 발견 및 AI 예약',
      description: '일본 최고의 100개 레스토랑을 탐색하세요. 다국어 지도와 AI 비서로 최고의 미식 경험을 제공합니다.',
      keywords: '일본 음식,백명점,레스토랑 예약,AI 비서,도쿄 맛집,TabeTabi',
    },
  },
  '/discovery': {
    'zh-CN': {
      title: '发现周边餐厅 | 食べ旅/美食之旅',
      description: '通过交互式地图和智能筛选发现周边的日本百名店与顶级餐厅。',
      keywords: '附近餐厅,日本美食地图,百名店查询,美食指南,TabeTabi',
    },
    'zh-TW': {
      title: '發現周邊餐廳 | 食べ旅/美食之旅',
      description: '透過互動式地圖和智能篩選發現周邊的日本百名店與頂級餐廳。',
      keywords: '附近餐廳,日本美食地圖,百名店查詢,美食指南,TabeTabi',
    },
    'en': {
      title: 'Discover Nearby Restaurants | TabeTabi',
      description: 'Discover nearby Japan Hyakumeiten and top-rated restaurants with interactive map and smart filters.',
      keywords: 'Nearby Restaurants,Japan Food Map,Hyakumeiten Search,Dining Guide,TabeTabi',
    },
    'ja': {
      title: '周辺のレストランを発見 | 食べ旅',
      description: 'インタラクティブなマップとスマートフィルターで周辺の百名店やトップクラスのレストランを発見。',
      keywords: '近くのレストラン,日本食マップ,百名店検索,グルメガイド,TabeTabi',
    },
    'ko': {
      title: '주변 레스토랑 발견 | TabeTabi',
      description: '인터랙티브 지도와 스마트 필터로 주변의 백명점 및 최고급 레스토랑을 발견하세요.',
      keywords: '주변 레스토랑,일본 음식 지도,백명점 검색,미식 가이드,TabeTabi',
    },
  },
}

const DEFAULT_LOCALE: Locale = 'zh-CN'

export function getPageMeta(pathname: string, locale?: string): PageMeta {
  const pageMeta = PAGE_META[pathname]
  if (!pageMeta) {
    return { title: 'TabeTabi', description: '' }
  }
  const resolvedLocale = (locale || DEFAULT_LOCALE) as Locale
  return pageMeta[resolvedLocale] || pageMeta[DEFAULT_LOCALE]
}
